import React from "react"
import { safebind } from "../../common/helpers"

export class TabItem extends React.PureComponent<{ name: string, caption: string | JSX.Element, children?: React.ReactNode, disabled?: boolean, margin?: number }> {
    render() {
        return <div>{this.props.children}</div>
    }
}

export class TabControl extends React.Component<{ onClickTab?: (tab: string) => void, justified?: boolean, tabsBelow?: boolean }, { selectedTab: string }> {

    constructor(props: {}) {
        super(props);
        this.state = { selectedTab: this.tabs()[0] && this.tabs()[0].props.name }
    }

    private onClickTab = (tab: string): void => {
        this.setState({ selectedTab: tab });
        if (this.props.onClickTab)
            this.props.onClickTab(tab);
    }

    private tabs = () => {
        return React.Children.map(this.props.children, (child: any, index: number) => {
            if (!child || child.type !== TabItem)
                return undefined;
            return child as TabItem;
        }).filter(x => x != undefined) as TabItem[];
    }


    render() {
        const className = "nav nav-tabs customtab" + (this.props.justified ? " nav-justified" : "");

        const content = <div className="tab-content">
            {this.tabs().map((tab, i) => (
                <div key={i} role="tabpanel" className={(this.state.selectedTab === tab.props.name ? "tab-pane fade in active show " : "tab-pane fade in ") + (tab.props.disabled ? "disabled " : "")}>
                    <div style={{ marginTop: tab.props.margin ?? 10 }}>{tab.props.children}</div>
                </div>
            ))}
        </div>;
        return (
            <div>
                {this.props.tabsBelow && content}
                <ul className={className} role="tablist">
                    {this.tabs().map((tab, i) => (
                        <li key={i} role="presentation" className="nav-item">
                            <a className={`nav-link h-100 ${this.state.selectedTab === tab.props.name ? "active" : ""}`} href="#" aria-controls={tab.props.name} role="tab" data-bs-toggle="tab"
                                onClick={safebind(this.onClickTab, this, tab.props.name)}>{tab.props.caption}
                            </a>
                        </li>
                    ))}
                </ul>
                {!this.props.tabsBelow && content}
            </div>
        );
    }
}
